module.exports = __webpack_public_path__ + "img/service-providers-icon.e8fe0ef9.png";